// Injected by esbuild `define` at build time. String literal in final bundle.
declare const __API_URL__: string;

export const config = {
  apiUrl: __API_URL__,
} as const;
